export const getters = {
  getAnnouncements: state => state.records,
  getUnreadCount: state => state.meta.unreadCount,
  hasPendingAnnouncements: state => state.records.length > 0,
  getUIFlags: state => state.uiFlags,
};
